import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

export default function HelpOverview(props) {
    //console.debug('RTS Break HelpOverview');

    return (
        <Box>
            <Typography>
                The Reel Flag is a marker you can use to identify a reel for whatever need your organization has.  It can be 
                used as a simple way to quickly identify reels with a specific attribute.
            </Typography>            
        </Box>
    );

}
